<!-- 
History for a levy collection.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="getBreadcrumbs('history')"
      :subtitle="statusDescription"
      title="History"
      subtitle-tooltip="Levy collection status"
      user-guide-topic="levy-collection-history"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" :sandbox="isSandbox" />
      </template>
    </our-heading>

    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="criteria.description"
        label="Description" 
        field="description" 
        @changed="$refs.history.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search levy collection history"
        show-all
        @changed="$refs.history.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        @selected="$refs.history.refresh()"
      />
    </our-search-bar>

    <system-log-listing
        ref="history"
        :endpoint="`/api/levy-collections/${levyCollectionId}/history`" 
        :export-endpoint="`/api/exports/levy-collections/${levyCollectionId}/history`"
        :export-validate-endpoint="`/api/exports/validate/levy-collections/${levyCollectionId}/history`"
      />
  </div>
</template>

<script>
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import levyCollectionMixins from "./mixins";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  components: {
    LevyCollectionNavigator,
    SystemLogListing
  },
  mixins: [levyCollectionMixins],
  data() {
    return {
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      criteriaMutation: mutation.LIST_SET_CRITERIA
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters("LevyCollectionAction");
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
